import React from "react"

import { graphql, useStaticQuery, Link } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import { getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"

import "./hero.css"

const PlesBanner = () => {
  // const { heroImage } = useStaticQuery(
  //   graphql`
  //     {
  //       heroImage: file(relativePath: { eq: "new-images/twig.jpeg" }) {
  //         childImageSharp {
  //           gatsbyImageData(
  //             width: 1600
  //             layout: CONSTRAINED
  //             placeholder: DOMINANT_COLOR
  //             formats: [AUTO, WEBP, AVIF]
  //           )
  //         }
  //       }
  //     }
  //   `
  // )

  // const heroImageData = getImage(heroImage)

  // Use like this:
  // const bgImage = convertToBgImage(heroImageData)

  // console.log("bgImage", bgImage)

  return (
    <>
      <div
        className="hero-banner hero-whitefade-ples-banner"
        style={{
          backgroundPosition: "top center",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-7 mr-auto">
              <div className="hero-procurement">
                <p className="h5 text-light-blue text-uppercase font-weight-bold mt-5 mt-md-0 mb-4">
                  QUICKBASE SOLUTIONS
                </p>
                <h1 className="page-title font-weight-medium mt-0 mb-4">
                  Á-La-Carte Support and Training to Maximize Post-Launch
                  Results
                </h1>
                <p>
                  We support your team after launch, providing the ongoing
                  support, documentation, and user training they need to
                  maximize the business value of your Quickbase applications.
                </p>
                <p>
                  <Link
                    aria-label="link"
                    className="font-weight-medium"
                    to="/contact/"
                  >
                    Enable Your Team
                    <i className="ml-2 item-arrow" aria-hidden="true"></i>
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PlesBanner
